// import Swal from "sweetalert2";
// import withReactContent from "sweetalert2-react-content";

function FormResponse() {
  window.location.href = `https://www.anandlab.com/thank-you`;
}
function CareerResponse() {
  window.location.href = `https://www.anandlab.com/thank-you`;
}
function NewsletterResponse() {
  window.location.href = `https://www.anandlab.com/thank-you`;
}

// const FormResponse = () => {
//     return withReactContent(Swal).fire({
//         title: `<h3>Thanks for your enquiry</h3>`,
//         html : `<p className="m-0">Our team will get back to you shortly.</p>`,
//         confirmButtonText :"Okay",
//         allowOutsideClick:false
//     });
// }
// const CareerResponse = () => {
//     return withReactContent(Swal).fire({
//         title: `<h3>Thank you for Applying</h3>`,
//         html : `<p className="m-0">Our team will get back to you shortly.</p>`,
//         confirmButtonText :"Okay",
//         allowOutsideClick:false
//     });
// }
// const NewsletterResponse = () => {
//     return withReactContent(Swal).fire({
//         title: `<h3>Thanks for Registering with us.</h3>`,
//         html : `<p className="m-0">you will get notified on our updates... </p>`,
//         confirmButtonText :"Okay",
//         allowOutsideClick:false
//     });
// }
export { FormResponse, NewsletterResponse, CareerResponse };
